import axiosClient from 'utils/axiosClient';
import api from 'api';
import {formData} from 'utils/helpers/formData';

const getBooks = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY.BOOKS.BOOKS, {params: data});
	return response.data;
};

const getBooksByID = async (id: any, data?: any) => {
	const response = await axiosClient.get(api.LIBRARY.BOOKS.BOOKS_BY_ID + id, data);
	return response.data;
};

const getBooksByBarcode = async (id: any) => {
	const response = await axiosClient.get(api.LIBRARY.BOOKS.BOOKS_BY_BARCODE + id);
	return response.data;
};

const createBook = async (data: any) => {
	const response = await axiosClient.post(api.LIBRARY.BOOKS.BOOKS, formData(data));
	return response.data;
};

const updateBook = async (id: number, data: any) => {
	const response = await axiosClient.patch(api.LIBRARY.BOOKS.BOOKS_BY_ID + id, formData(data));
	return response.data;
};

const deleteBooks = async (ids: any) => {
	const response = await axiosClient.delete(api.LIBRARY.BOOKS.BOOKS_BY_ID + ids);
	return response.data;
};

const service = {
	getBooks,
	getBooksByID,
	getBooksByBarcode,
	createBook,
	updateBook,
	deleteBooks
};

export default service;
